import React, { useState, useEffect } from "react";
import { Tabs,Radio} from "antd";
import { getAccessTokenApi } from "../../../api/auth";
import { post } from "../../../api/post";
import PolygonGraph from "../../../components/Admin/Graphs/polygon/Polygon";
import { getSimulations } from "../../../api/user";
import Analysis from "../../../components/Admin/Analysis";

import "./GraphMult.scss";


export default function GraphMult(props) {
  const [data_OUT1_TOTAL, setdata_OUT1_TOTAL] = useState([]);
  const [hasRender,sethasRender]= useState(false);
  const [estanCargadas,setestanCargadas]= useState(true);
  const [ sliders, setsliders] = useState([]);
  const [nombres, setnombres] = useState([]); 

  
  const token = getAccessTokenApi(); //Authorization token
  let search = window.location.search;
  let params = new URLSearchParams(search);
  let code = params.get("id");
  // var id_excel = code.split(".")[0];
  var id_excel = code.replace('.xlsx','');



  useEffect(  () =>  {
    var DATA
    var DATA_SIM
    var data_OUT1_TOTAL_ =[]
    var name_aux=[id_excel];

    const dat = {
      isMain: true,
      subsimul:''
    }
    post(dat,'getExcelRaw','getExcelRaw',`/${id_excel}`).then((response) => {
    
    // getExcelFromID(token, id_excel,true,'').then((response) => {
      DATA = response.DATA;
      DATA_SIM = DATA.simulaciones;
      // console.log('getExcelFromID: ',DATA);
      console.log('DATA_SIM: ',DATA_SIM);
      if(DATA.pesos[0]!==undefined){ 
        setsliders(DATA.pesos[0]);
        // console.log('sliders:',sliders,DATA.pesos[0])
      }

      for(var i=0;i<DATA_SIM.length;i++){
        name_aux=[...name_aux,DATA_SIM[i].nombreInput]
        if(DATA_SIM[i].nombreOutput.length<2){
          setestanCargadas(false)
          break
        }
      }
      setnombres(name_aux)
      // console.log('name_aux:',name_aux)
      
      data_OUT1_TOTAL_ =[DATA.OUT1_Total]
      console.log('data_OUT1_TOTAL_: ',DATA_SIM.length,data_OUT1_TOTAL_)
      for(var i=0;i<DATA_SIM.length;i++){
        // console.log('i: ',i,data_OUT1_TOTAL_)
        
        data_OUT1_TOTAL_=[...data_OUT1_TOTAL_,DATA_SIM[i].OUT1_Total]
        // console.log('i+: ',i,data_OUT1_TOTAL_)
      }
      setdata_OUT1_TOTAL(data_OUT1_TOTAL_)
      // console.log('data_OUT1_TOTAL_:',data_OUT1_TOTAL_)
      sethasRender(true)
     
      // console.log('holas',DATA.pesos[0],' ',data_OUT1_TOTAL_,' ',name_aux)
    })
  }, []); //Solo se refresca si cambian estos


//  console.log('hola',sliders,'   ',hasRender,' ',data_OUT1_TOTAL,' ',nombres)
  return (
    <>
     { (!hasRender)
        ?<div className="cargand">
          <h2  style={{fontFamily:'report-bold'}}>Loading ...</h2>
          <div className="cargando">
          
        </div>
        </div>
        :<div className="site-card-wrapper">
          <Tabs defaultActiveKey="1" onChange={() => {}} >
            <Tabs.TabPane tab="Analysis" key="Analysis" >
              {(estanCargadas)? 
              <>
                  <h1 className="titulos3" >SIMULATIONS COMPARE </h1>
                    <PolygonGraph nombres={nombres} datos={data_OUT1_TOTAL}></PolygonGraph>
                    
                  { (sliders.length<1||sliders==undefined)
                  ?<h1 className="titulos3" >ADD WEIGHTS TO SHOW THE RANKING</h1>
                  :<div>
                    <h1 className="titulos3" >WEIGHT INPUTS AND RANKING </h1>
                    <Analysis sliders={sliders} datos={data_OUT1_TOTAL}></Analysis>
                  </div>
                  }
                </>
                 :<h1 className="titulos3" >UPLOAD ALL THE SIMULATIONS</h1>
             }
            </Tabs.TabPane>
          </Tabs>
        </div>}
    </>
  );
}
